import { useEffect } from "react";
import type { PaymentGatewayProps } from "../../lib/payment-gateways";
import { CreditCard, ShieldCheck } from "lucide-react";

export default function NexiPaymentForm({
  onReady,
  amount,
  depositLabel,
}: PaymentGatewayProps) {
  useEffect(() => {
    onReady(true);
  }, [onReady]);

  return (
    <div className="space-y-2 py-2">
      <div className="flex items-center gap-2 text-sm font-medium text-emerald-700 dark:text-emerald-400">
        <ShieldCheck className="h-4 w-4" />
        <span>
          Pagamento sicuro protetto da cifratura 3D Secure / Nexi XPay
        </span>
      </div>
      <p className="text-xs text-muted-foreground">
        Cliccando su "Conferma Prenotazione", verrai reindirizzato alla pagina
        protetta di Nexi XPay per completare
        {amount != null ? (
          <>
            {" "}
            il pagamento di{" "}
            <strong className="text-foreground font-semibold">
              {amount.toFixed(2)} €
            </strong>
            {depositLabel ? ` (Caparra ${depositLabel})` : ""}
          </>
        ) : (
          " la transazione"
        )}{" "}
        in tutta sicurezza.
      </p>
    </div>
  );
}
